import { render, staticRenderFns } from "./server-edit.vue?vue&type=template&id=51ed14d6&"
import script from "./server-edit.vue?vue&type=script&lang=ts&"
export * from "./server-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports